var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "cardWrap",
        "clearfix",
        "gbCardWrap",
        _vm.companyType == 5 ? "mapCardWrap" : "",
      ],
    },
    [
      _c(
        "div",
        {
          key: "" + _vm.rendKey + _vm.baseData.hid,
          class: [
            "cardText",
            "clearfix",
            _vm.baseData.isClick ? "haveBrowsed" : "",
          ],
          on: {
            click: function ($event) {
              return _vm.titleHandle(false)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "cardLeft" },
            [
              _c("div", { staticClass: "cardLfTop clearfix" }, [
                _c(
                  "div",
                  {
                    staticClass: "cdfpChecked",
                    staticStyle: { float: "left" },
                  },
                  [_vm._t("default")],
                  2
                ),
                _c("div", { staticClass: "logoAndStar clearfix" }, [
                  _vm.baseData.logoPath
                    ? _c("div", { staticClass: "logo" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.repliceHttps(_vm.baseData.logoPath),
                            alt: "",
                            srcset: "",
                          },
                          on: {
                            "~error": function ($event) {
                              _vm.baseData.logoPath = null
                            },
                          },
                        }),
                      ])
                    : _c(
                        "div",
                        {
                          class: [
                            "logo2",
                            { aliasLineHeight: _vm.aliasLineHeight },
                          ],
                          style: "background:" + _vm.backgroundColor,
                        },
                        [_vm._v(_vm._s(_vm.setLineHeight(_vm.baseData.alias)))]
                      ),
                ]),
                _c("div", { staticClass: "details" }, [
                  _c(
                    "div",
                    { staticClass: "nameWrap mb-10" },
                    [
                      _c("div", { staticClass: "company-name" }, [
                        _c("span", {
                          staticClass: "name",
                          domProps: {
                            innerHTML: _vm._s(_vm.companyNameColor || "--"),
                          },
                        }),
                        _c("span", { staticClass: "copy-box" }, [
                          _c(
                            "i",
                            {
                              staticClass: "el-icon-document-copy copy-icon",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.onCopy(_vm.companyNameColor, "a")
                                },
                              },
                            },
                            [_vm._v("复制")]
                          ),
                        ]),
                      ]),
                      _vm.baseData.regStatus
                        ? _c(
                            "el-tag",
                            {
                              staticClass: "tgP tg",
                              attrs: { size: "mini", effect: "plain" },
                            },
                            [_vm._v(_vm._s(_vm.baseData.regStatus))]
                          )
                        : _vm._e(),
                      _vm.baseData.unlockType === 2
                        ? _c("div", { staticClass: "playGet font-12" }, [
                            _vm._v("赠"),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "star ml-6" }, [
                        _c("div", {
                          class: ["bg", { unstar: !_vm.baseData.star }],
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleStarB.apply(null, arguments)
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm.companyTags.length
                    ? _c(
                        "div",
                        { staticClass: "bqTag" },
                        _vm._l(_vm.companyTags, function (tag, i) {
                          return _c(
                            "p",
                            {
                              key: i,
                              staticClass: "tag-title",
                              class: "tag-title-" + tag.type,
                            },
                            [_vm._v(_vm._s(tag.tagName))]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c("dl", { staticClass: "text" }, [
                    _c("dd", { staticClass: "mr-10" }, [
                      _c("div", { staticClass: "textOverflow" }, [
                        _c("span", [_vm._v("企业法人: ")]),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.baseData.legalPersonName || "--"
                            ),
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "textOverflow" }, [
                        _c("span", [_vm._v("企业规模: ")]),
                        _c("span", [_vm._v(_vm._s(_vm.staffSize))]),
                      ]),
                    ]),
                    _c("dd", { staticClass: "mr-10" }, [
                      _c("div", { staticClass: "textOverflow" }, [
                        _c("span", [_vm._v("注册资本: ")]),
                        _vm.baseData.regCapital
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.Global.formatAmount(
                                    _vm.baseData.regCapital
                                  )
                                )
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                _vm._s(_vm.Global.formatAmount(_vm.regCapital))
                              ),
                            ]),
                      ]),
                      _c("div", { staticClass: "textOverflow" }, [
                        _c("span", [_vm._v("企业网址: ")]),
                        _vm.companyWeb
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#333333",
                                  "font-size": "13px",
                                },
                                attrs: { target: "_blank" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.setlll(_vm.companyWeb)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.companyWeb))]
                            )
                          : _c("span", [_vm._v("--")]),
                      ]),
                    ]),
                    _c("dd", { staticClass: "mr-10" }, [
                      _c("div", { staticClass: "textOverflow" }, [
                        _c("span", [_vm._v("成立日期: ")]),
                        _vm.baseData.establishTime
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatTime")(
                                    _vm.baseData.establishTime
                                  )
                                )
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatTime")(
                                    _vm.baseData.estiblishTime
                                  )
                                )
                              ),
                            ]),
                      ]),
                      _c("div", { staticClass: "textOverflow" }, [
                        _c("span", [_vm._v("所属行业: ")]),
                        _c(
                          "span",
                          {
                            staticClass: "span02",
                            attrs: { title: _vm.companyIndustry },
                          },
                          [_vm._v(_vm._s(_vm.companyIndustry))]
                        ),
                      ]),
                    ]),
                    _vm.subscriptionType
                      ? _c(
                          "dd",
                          { staticClass: "mr-10" },
                          [
                            _vm.subscriptionType == 1
                              ? [
                                  _c("div", { staticClass: "textOverflow" }, [
                                    _c("span", [_vm._v("商机时间: ")]),
                                    _vm.baseData.establishTime
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatTime")(
                                                _vm.baseData.establishTime
                                              )
                                            )
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatTime")(
                                                _vm.baseData.estiblishTime
                                              )
                                            )
                                          ),
                                        ]),
                                  ]),
                                  _c("div", {
                                    staticClass: "textOverflow",
                                    staticStyle: { height: "17px" },
                                  }),
                                ]
                              : _vm._e(),
                            _vm.subscriptionType == 2
                              ? [
                                  _c("div", { staticClass: "textOverflow" }, [
                                    _c("span", [_vm._v("商机时间: ")]),
                                    _vm.baseData.icpLastedTime
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatTime")(
                                                _vm.baseData.icpLastedTime
                                              )
                                            )
                                          ),
                                        ])
                                      : _c("span", [_vm._v("--")]),
                                  ]),
                                  _c("div", { staticClass: "textOverflow" }, [
                                    _c("span", [_vm._v("新增ICP: ")]),
                                    _vm.icpDomain
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#333333",
                                              "font-size": "13px",
                                            },
                                            attrs: { target: "_blank" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.setlll(_vm.icpDomain)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.icpDomain))]
                                        )
                                      : _c("span", [_vm._v("--")]),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "address textOverflow" }, [
                    _c("span", [_vm._v("注册地址: ")]),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(this.address || "--") },
                    }),
                  ]),
                  _vm.showRecommend && _vm.baseData.similarValue
                    ? _c(
                        "div",
                        {
                          class: [
                            "recommend",
                            "clearfix",
                            { "recommend-noMargin": !_vm.xiaoT },
                          ],
                        },
                        [
                          _vm.baseData.similarValue
                            ? _c("div", { staticClass: "tRecommend" }, [
                                _vm._m(0),
                                _c("div", { staticClass: "text2" }, [
                                  _c("span", { staticClass: "textOverflow" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.baseData.similarValue) +
                                        " "
                                    ),
                                  ]),
                                  _vm.baseData.similarity
                                    ? _c("span", [
                                        _vm._v("，相似度："),
                                        _c("i", [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                (_vm.baseData.similarity *
                                                  10000) /
                                                100
                                              ).toFixed(2)
                                            ) + "% "
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm.companyType == 1
                ? [
                    _vm.searchType == 0 &&
                    _vm.baseData.highlightFields &&
                    _vm.baseData.highlightFields.length > 0
                      ? _c(
                          "div",
                          { staticClass: "flag-box" },
                          [
                            _vm._l(
                              _vm.baseData.highlightFields.slice(0, 4),
                              function (item, index) {
                                return [
                                  _vm.baseData[item] && _vm.conversionZh[item]
                                    ? _c(
                                        "div",
                                        {
                                          key: item + index,
                                          staticClass: "tm textOverflow",
                                          attrs: {
                                            title: _vm.removeHtml(
                                              _vm.unique(_vm.baseData[item])
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.goDetail(item)
                                            },
                                          },
                                        },
                                        [
                                          item == "productName"
                                            ? _c("img", {
                                                attrs: {
                                                  src: require("@/assets/gbIcon/link_icon.svg"),
                                                  alt: "",
                                                  srcset: "",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            _vm._s(_vm.conversionZh[item]) +
                                              "："
                                          ),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.unique(_vm.baseData[item])
                                              ),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              }
                            ),
                            _vm.baseData.highlightFields.length > 4
                              ? _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      "popper-class": "more-flag-box",
                                      placement: "top",
                                      width: "282",
                                      trigger: "hover",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "content" },
                                      [
                                        _vm._l(
                                          _vm.baseData.highlightFields.slice(4),
                                          function (item, index) {
                                            return [
                                              _vm.baseData[item] &&
                                              _vm.conversionZh[item]
                                                ? _c(
                                                    "p",
                                                    {
                                                      key: item + index,
                                                      staticClass:
                                                        "tm textOverflow",
                                                      attrs: {
                                                        title: _vm.removeHtml(
                                                          _vm.unique(
                                                            _vm.baseData[item]
                                                          )
                                                        ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.goDetail(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.conversionZh[
                                                              item
                                                            ]
                                                          ) +
                                                          "："
                                                      ),
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.unique(
                                                              _vm.baseData[item]
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "more-btn",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [_vm._v("更多")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.searchType == 1 && _vm.baseData.historyName
                      ? _c("div", { staticClass: "flag-box" }, [
                          _vm.baseData.historyName
                            ? _c(
                                "div",
                                {
                                  staticClass: "tm textOverflow",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.goDetailTab("", "")
                                    },
                                  },
                                },
                                [
                                  _vm._v(" 曾用名："),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.unique(_vm.baseData.historyName)
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm.searchType == 2 && _vm.baseData.businessScope
                      ? _c("div", { staticClass: "flag-box" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tm textOverflow",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.goDetailTab(1, 1)
                                },
                              },
                            },
                            [
                              _vm._v(" 经营范围："),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.unique(_vm.baseData.businessScope)
                                  ),
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.searchType == 3 && _vm.baseData.mainProduct
                      ? _c("div", { staticClass: "flag-box" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tm textOverflow",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.goDetailTab(2, 4)
                                },
                              },
                            },
                            [
                              _vm._v(" 主营产品："),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.unique(_vm.baseData.mainProduct)
                                  ),
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.searchType == 4 && _vm.baseData.executives
                      ? _c("div", { staticClass: "flag-box" }, [
                          _vm.baseData.executives
                            ? _c(
                                "div",
                                {
                                  staticClass: "tm textOverflow",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.goDetailTab(1, 2)
                                    },
                                  },
                                },
                                [
                                  _vm._v(" 主要人员："),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.unique(_vm.baseData.executives)
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm.searchType == 5 && _vm.baseData.patentName
                      ? _c("div", { staticClass: "flag-box" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tm textOverflow",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.goDetailTab(4, 1)
                                },
                              },
                            },
                            [
                              _vm._v(" 专利名称："),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.unique(_vm.baseData.patentName)
                                  ),
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.searchType == 6 && _vm.baseData.address
                      ? _c("div", { staticClass: "flag-box" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tm textOverflow",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.goDetailTab("", "")
                                },
                              },
                            },
                            [
                              _vm._v(" 通讯地址："),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.unique(_vm.baseData.address)
                                  ),
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.searchType == 7 && _vm.baseData.bidKeyWord
                      ? _c("div", { staticClass: "flag-box" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tm textOverflow",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.goDetailTab(5, 1)
                                },
                              },
                            },
                            [
                              _vm._v(" 推广关键词："),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.unique(_vm.baseData.bidKeyWord)
                                  ),
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c("div", { staticClass: "youBtn clearfix" }, [
            _c(
              "div",
              { staticClass: "btns" },
              [
                _vm.baseData.unlock
                  ? _c(
                      "div",
                      { staticClass: "telList" },
                      [
                        _vm.baseData.contactListVOS
                          ? [
                              _vm._l(
                                _vm.getSortPhone(
                                  _vm.baseData.contactListVOS.slice(0, 3)
                                ),
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "item clearfix",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "tel",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(_vm._s(item.content) + " "),
                                          !item.content.includes("*")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "telCopy",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.onCopy(
                                                        item.content,
                                                        "b",
                                                        index,
                                                        _vm.baseData.hid
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "el-icon-document-copy",
                                                    },
                                                    [_vm._v("复制")]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c("div", { staticClass: "telTag" }, [
                                        item.contactName
                                          ? _c(
                                              "i",
                                              {
                                                staticClass: "tag",
                                                staticStyle: {
                                                  "margin-left": "8px",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(item.contactName))]
                                            )
                                          : _vm._e(),
                                        item.isKeyContact
                                          ? _c(
                                              "i",
                                              {
                                                staticClass: "tag",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                  },
                                                },
                                              },
                                              [_vm._v("关键人")]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              _vm.baseData.contactListVOS &&
                              _vm.baseData.contactListVOS.length > 3
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "moreTel",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.lookNumber.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("查看详情>>")]
                                  )
                                : _vm._e(),
                            ]
                          : [_vm._m(1)],
                      ],
                      2
                    )
                  : _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "interestExpire",
                            rawName: "v-interestExpire",
                          },
                        ],
                        attrs: {
                          type: "dialog-confirm",
                          size: "default",
                          w88: "",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.lookNumber.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("立即解锁")]
                    ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm.baseData.receive
        ? _c("div", { staticClass: "transform-icon" }, [
            _c("img", { attrs: { src: require("@/assets/zhuanhua.svg") } }),
          ])
        : _vm._e(),
      _vm.drawerShow !== null
        ? _c("ViewNumber", {
            ref: "vNumber",
            attrs: { show: _vm.drawerShow, companyStatus: _vm.companyStatus },
            on: {
              "update:show": function ($event) {
                _vm.drawerShow = $event
              },
              "unlock-change": _vm.unlockChange,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", {
        attrs: { src: require("@/assets/gbIcon/xt.svg"), alt: "", srcset: "" },
      }),
      _c("span", [_vm._v(" 小T智 ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "noresult" }, [
      _c("img", { attrs: { src: require("@/assets/noresult.svg"), alt: "" } }),
      _c("i", [_vm._v("暂无手机号")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }